export const AddressModelModule = angular
    .module('app.services.model.models.addressModel', [])
    .value('addressModel', {
        isPrimary: ['Boolean', false],
        mailingAddress: {
            address1: 'String',
            city: 'String',
            country: ['String', 'US'],
            postalCode: 'String',
            state: 'String'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/address.model.js